import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface TickerItem {
  title: string;
  rate: string;
  apr: string;
  up: boolean;
}

@Component({
  selector: 'app-ticker',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ticker.component.html',
  styleUrl: './ticker.component.scss'
})
export class TickerComponent {
  tickerItems: TickerItem[] = [
    { title: '30-Yr Fixed', rate: '6.72%', apr: 'APR 6.89%', up: true },
    { title: '15-Yr Fixed', rate: '6.11%', apr: 'APR 6.31%', up: true },
    { title: 'FHA Loan', rate: '6.33%', apr: 'APR 7.04%', up: false },
    { title: 'VA Loan', rate: '6.02%', apr: 'APR 6.22%', up: true },
    { title: 'Jumbo', rate: '6.88%', apr: 'APR 7.01%', up: false },
    { title: 'USDA', rate: '6.15%', apr: 'APR 6.35%', up: false },
    { title: 'DSCR', rate: '7.25%', apr: 'Investor', up: false },
    { title: 'Non-QM', rate: '7.50%', apr: 'Alt Doc', up: false }
  ];
}